import { useCounterStore } from "@/stores/counter.store";
import { ref } from "vue";

export const useFullPageLoader = () => {
  const counterStore = useCounterStore();
  const showLoading = ref(false);

  counterStore.$subscribe((_, state) => {
    let found = false;
    for (const counter of state.counters) {
      if (counter.name === "api") {
        showLoading.value = counter.count > 0;
        found = true;
        break;
      }
    }

    if (!found) {
      showLoading.value = false;
    }
  });

  return {
    showLoading
  };
};
